import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { DriversService } from "./drivers.service";
import * as XLSX from "xlsx";
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";

@Component({
  selector: "app-drivers",
  templateUrl: "./drivers.component.html",
  styleUrls: ["./drivers.component.sass"],
})
export class DriversComponent implements OnInit {
  itemsPerPage = 5;

  allDriversList: any;
  totalItems: any;
  page_active: number = 0;

  allDeletedDriversList: any;
  totalDeletedItems: any;
  page_Deleted: number = 0;

  searchBy = "";
  searchText: any = "";
  isDeleted: number;

  closeResult: string;
  viewAllData: any;

  nameAsPerBank: "";
  bankAccountNumber: any;
  ifscCode: any;
  bankName: any;
  upiMobileNumber: any;
  paymentApp: any;
  _id = "";
  userId = "";
  firstName = "";
  lastName = "";
  address = "";
  city = "";
  pinCode = "";
  state = "";
  phoneNumber = "";
  emailId = "";
  activationStatus = "";
  verificationStatus = "";
  ipAddress = "";
  kyc = "";
  refBy = "";
  refCode = "";
  source = "";
  two_factor = "";
  userType = "";
  verid = "";
  currentBalance = "";
  isPhoneVerified = "";
  rating = "";
  status: any = "";
  createdOnTS: any;
  vehicleType: "";
  totalPages: any;
  driverId: any;
  viewAllData1: any;
  driverDocumentsData = [];
  vehicleNumber: any;
  homeStopLocation: any;
  homeStopLat: any;
  homeStopLng: any;
  upiID: any;
  isBannerPasted: any;
  constructor(
    private spinner: NgxSpinnerService,
    private driverService: DriversService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getDrivers();
    this.getDeletedDriver();
    this.getVehicles();
  }
  // totalAcDPages:any
  // currentACPage:number=0;
  getDrivers() {
    this.spinner.show();
    let data = {
      isDeleted: 0,
      perPage: this.itemsPerPage,
      page: 0,
      verificationStatus: 2,
    };
    // console.log(data)
    this.driverService.getDrivers(data).subscribe((result: any) => {
      // console.log('Data',result);
      this.spinner.hide();
      if (result.statusCode == 200) {
        this.allDriversList = result.data;
        this.totalItems = result.totalRecords;
      } else {
        this.allDriversList = [];
      }
    });
  }

  gty(itemsPerPage: 0) {
    this.spinner.show();
    let data = {
      isDeleted: 0,
      perPage: this.itemsPerPage,
      page: this.page_active - 1,
      verificationStatus: 2,
    };
    this.driverService.getDrivers(data).subscribe((result: any) => {
      // console.log('Data',result);
      this.spinner.hide();
      if (result.statusCode == 200) {
        this.allDriversList = result.data;
      } else {
        this.allDriversList = [];
      }
    });
  }

  totalDelDPages: any;
  currentDelDPage: number = 0;
  getDeletedDriver() {
    this.spinner.show();
    let data = {
      isDeleted: 1,
      perPage: 5,
      page: 0,
    };
    this.driverService.getDeletedDrivers(data).subscribe((result: any) => {
      // console.log('Deleted Data',result);
      this.spinner.hide();
      if (result.statusCode == 200) {
        this.allDeletedDriversList = result.data;
        this.totalDeletedItems = result.totalRecords;
      } else {
        this.allDeletedDriversList = [];
      }
    });
  }

  gty_Del(page_Deleted: 0) {
    this.spinner.show();
    let data = {
      isDeleted: 0,
      perPage: this.itemsPerPage,
      page: this.page_Deleted - 1,
      verificationStatus: 2,
    };
    this.driverService.getDeletedDrivers(data).subscribe((result: any) => {
      // console.log('Deleted Data ',result);
      this.spinner.hide();
      if (result.statusCode == 200) {
        this.allDeletedDriversList = result.data;
      } else {
        this.allDeletedDriversList = [];
      }
    });
  }

  getDriverDocuments() {
    this.spinner.show();
    let data = {
      driverId: this.driverId,
    };
    this.driverService
      .getDriverUploadedDocuments(data)
      .subscribe((result: any) => {
        if (result.statusCode == 200) {
          // console.log(result);
          this.driverDocumentsData = [];
          this.driverDocumentsData = result.data;
          this.spinner.hide();
        } else {
          this.spinner.hide();
          this.toastr.error(result.message);
        }
      });
  }

  search() {
    this.spinner.show();
    let data = {
      fieldName: this.searchBy,
      searchText: this.searchText,
    };
    console.log(data);
    this.driverService.searchDrivers(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        this.spinner.hide();
        this.allDriversList = result.data.filter(
          (driver) => driver.isDeleted === 0 && driver.verificationStatus === 2
        );
        this.allDeletedDriversList = result.data.filter(
          (driver) => driver.isDeleted === 1
        );
      } else {
        this.spinner.hide();
        this.allDriversList = [];
        this.allDeletedDriversList = [];
      }
    });
  }

  editDriver(content1: any, data: any) {
    this.openViewDeatilsModal(content1);
    this._id = data._id;
    this.userId = data.userID;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.address = data.address;
    this.city = data.city;
    this.pinCode = data.pincode;
    this.state = data.state;
    this.phoneNumber = data.phoneNumber;
    this.vehicleNumber = data.vehicleNumber;
    this.emailId = data.emailId;
    this.userType = data.userType;
    this.source = data.source;
    this.refCode = data.refCode;
    this.activationStatus = data.activationStatus;
    this.kyc = data.kyc;
    this.two_factor = data.two_factor;
    this.isPhoneVerified = data.isPhoneVerified;
    this.refBy = data.refBy == null ? "null" : data.refBy;
    this.ipAddress = data.ipAddress;
    this.currentBalance = data.currentBalance;
    (this.createdOnTS = data.createdOnTS * 1000),
      (this.verificationStatus = data.verificationStatus),
      (this.isDeleted = data.isDeleted);
    this.status = data.status;
    (this.vehicleType = data.vehicleType),
      (this.nameAsPerBank = data.nameAsPerBank),
      (this.bankAccountNumber = data.bankAccountNumber),
      (this.bankName = data.bankName),
      (this.ifscCode = data.ifscCode),
      (this.upiMobileNumber = data.upiMobileNumber),
      (this.paymentApp = data.paymentApp),
      (this.homeStopLocation = data.homeStopLocation),
      (this.homeStopLat = data.homeStopLat),
      (this.homeStopLng = data.homeStopLng),
      (this.upiID = data.upiID),
      (this.isBannerPasted = data.isBannerPasted);
  }

  updateDriver() {
    let data = {
      id: this._id,
      userId: this.userId,
      firstName: this.firstName,
      lastName: this.lastName,
      address: this.address,
      city: this.city,
      pinCode: this.pinCode,
      state: this.state,
      phoneNumber: this.phoneNumber,
      emailId: this.emailId,
      activationStatus: this.activationStatus,
      verificationStatus: this.verificationStatus,
      ipAddress: this.ipAddress,
      kyc: this.kyc,
      refBy: this.refBy,
      refCode: this.refCode,
      source: this.source,
      two_factor: this.two_factor,
      userType: this.userType,
      vehicleType: this.vehicleType,
      vehicleNumber: this.vehicleNumber,
      homeStopLocation: this.homeStopLocation,
      homeStopLng: this.homeStopLng,
      homeStopLat: this.homeStopLat,
      verid: this.verid,
      currentBalance: this.currentBalance,
      isPhoneVerified: this.isPhoneVerified,
      rating: this.rating,
      createdOn: this.createdOnTS,
      status: this.status,
      isDeleted: this.isDeleted,
      nameAsPerBank: this.nameAsPerBank,
      bankAccountNumber: this.bankAccountNumber,
      bankName: this.bankName,
      ifscCode: this.ifscCode,
      upiMobileNumber: this.upiMobileNumber,
      upiID: this.upiID,
      paymentApp: this.paymentApp,
      isBannerPasted: this.isBannerPasted,
    };
    console.log(data);
    this.spinner.show();
    this.driverService.updateDriver(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        // console.log(result)
        this.spinner.hide();
        this.toastr.success(result.message);
        this.getDrivers();
        this.modalService.dismissAll();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  allVehiclesList: any;
  getVehicles() {
    this.spinner.show();
    let data = { currentStatus: 1, isDeleted: 0 };
    this.driverService.getAllvehicles(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        this.spinner.hide();
        // console.log(result)
        this.allVehiclesList = result.data.filter(
          (vehicle: any) => vehicle.currentStatus !== 0
        );
      } else {
        this.spinner.hide();
        this.allVehiclesList = [];
      }
    });
  }

  exportToExcel() {
    // Find the active tab content
    const activeTab = document.querySelector(".tab-pane.active");
    if (!activeTab) {
      console.error("No active tab found!");
      return;
    }
    const element = activeTab.querySelector("#excel-table");
    if (!element) {
      console.error("Table not found in the active tab!");
      return;
    }
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    // Generate workbook and add the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    // Save to file
    XLSX.writeFile(wb, "Drivers_Report.xlsx");
  }

  viewDetails(content1, data) {
    this.viewAllData = data;
    this.openViewDeatilsModal(content1);
  }
  viewDetails1(content2, data) {
    this.viewAllData1 = data;
    this.driverId = data._id;
    this.openViewDeatilsModal(content2);
  }

  openViewDeatilsModal(content) {
    this.modalService.open(content, { size: "lg" }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  getHomeStopData(address: any) {
    this.homeStopLocation = address.formatted_address;
    this.homeStopLat = address.geometry.location.lat();
    this.homeStopLng = address.geometry.location.lng();
    // console.log("lat", this.homeStopLat, "lng", this.homeStopLng, "home stop", this.homeStopLocation)
  }

  routeWalletDetails(data: any) {
    this.router.navigate(["dashboard/driver/wallet"], {
      queryParams: { id: data._id },
      state: {
        driverData: {
          name: data.firstName + " " + data.lastName,
          phoneNumber: data.phoneNumber,
          vehicleType: data.vehicleType,
        },
      },
    });
  }
  viewReviews(data: any) {
    this.router.navigate(["dashboard/driver-reviews"], {
      queryParams: { id: data._id, name:data.firstName + data.lastName, phoneNumber:data.phoneNumber },
    });
  }
}
